import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AIConcierge } from "./AIConcierge";
import { api } from "@/lib/api";

const BackButton = () => {
  const nav = useNavigate();
  return (
    <button data-testid="global-back-btn" onClick={() => nav(-1)} aria-label="Go back"
      className="fixed left-4 top-[84px] z-40 flex items-center gap-1.5 rounded-full bg-white/90 px-4 py-2 text-sm font-medium text-ink shadow-md backdrop-blur transition-colors hover:bg-white">
      <ArrowLeft size={16} /> Back
    </button>
  );
};

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) {
      localStorage.setItem("elite_ref", ref);
      api.post("/referrals/track", { code: ref }).catch(() => {});
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Elite STR Hosting Co. | Luxury Texas Hill Country Rentals";
  }, [pathname]);
  const isAdmin = pathname.startsWith("/admin");
  const showBack = !isAdmin && pathname !== "/" && !pathname.startsWith("/rentals/");
  return (
    <div className="App">
      {!isAdmin && <Navbar />}
      {showBack && <BackButton />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <AIConcierge />}
    </div>
  );
};
